<div class="app-wrapper"
    [attr.data-sidepanel-enabled]="sidepanelEnabled"
    [ngClass]="{'canvas-open': canvasControlsExpanded }">
    <context-message></context-message>
    <router-outlet></router-outlet>
</div>
